module.exports = __webpack_public_path__ + "img/ssyx_31.999b6ef5.jpg";